import {
    BASE_URL, 
    PATCH, 
    SUBMIT_STOP_BROADCAST,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const submitStopBroadcast = async (payload ,id) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${SUBMIT_STOP_BROADCAST}${id}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };